import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaUsers } from 'react-icons/fa';
import PayslipStateBadge from './PayslipStateBadge';

const applyEmployeeSelection = (selectedEmployees, employee, checked) => (
    checked
        ? [...selectedEmployees, employee]
        : selectedEmployees.filter(e => e.id !== employee.id)
);

const EmployeeListModal = ({
    employees,
    selectedEmployees,
    setSelectedEmployees,
}) => {
    const { t } = useTranslation();

    const handleToggle = (employee, checked) => {
        setSelectedEmployees(prev => applyEmployeeSelection(prev, employee, checked));
    };

    return (
    <div className="h-96 overflow-y-auto border border-gray-200">
        {employees.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 text-gray-500">
                <FaUsers size={32} className="mb-3" />
                <p className="text-lg font-medium">{t('employeeListModal.noPendingPayslip')}</p>
                <p className="text-sm">{t('employeeListModal.noEmployeeToProcess')}</p>
            </div>
        ) : (
            <div className="divide-y divide-gray-200">
                {employees.map(emp => (
                    <label 
                        key={emp.id} 
                        className="flex items-center gap-4 p-4 hover:bg-gray-50 cursor-pointer transition-colors duration-200"
                        htmlFor={`emp-modal-checkbox-${emp.id}`}
                    >
                        <input
                            type="checkbox"
                            checked={selectedEmployees.some(e => e.id === emp.id)}
                            onChange={e => handleToggle(emp, e.target.checked)}
                            className="w-4 h-4 text-[--color-primary] border-gray-300 rounded focus:ring-[--color-primary]"
                            id={`emp-modal-checkbox-${emp.id}`}
                        />
                        <div className="flex-1 min-w-0">
                            <p className="font-medium text-gray-900 truncate">
                                {emp.name || emp.email || t('employeeListModal.employeeFallback', { id: emp.id })}
                            </p>
                            {emp.email && (
                                <p className="text-sm text-gray-500 truncate">{emp.email}</p>
                            )}
                        </div>
                        <div className="flex items-center gap-2">
                            {emp.payslip_state && (
                                <PayslipStateBadge state={emp.payslip_state} />
                            )}
                        </div>
                    </label>
                ))}
            </div>
        )}
    </div>
    );
};

export default EmployeeListModal;